var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F3BA2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m20.663 17.913 2.713 2.71L16 28l-7.377-7.377 2.716-2.708 4.66 4.66 4.664-4.662ZM13.247 16 16 13.247 18.753 16 16 18.753 13.247 16Zm12.041-2.711L28 16.001l-2.712 2.712-2.712-2.712 2.712-2.712Zm-18.576-.001 2.712 2.711-2.712 2.713L4 16l2.712-2.712ZM16 4l7.375 7.375-2.712 2.712L16 9.424l-4.661 4.661-2.712-2.712L16 4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/Binance.009febb4e0308611063ed57ee0652244.svg";
export { ForwardRef as ReactComponent };